import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getToken } from '../../../../features/token/tokenSaver';
import { getAdvertiserAccount } from '../../../../services/getAdvertiserAccount';
import { platformAgreementPath } from '../../../../utils/platformAgreementUrl';

/** Legacy dashboard route — redirect to the public agreement page with slot cost. */
export default function AdvertiserDashboardAdvertisingAgreement() {
    const token = useSelector(getToken);
    const navigate = useNavigate();

    useEffect(() => {
        const redirect = (slotCost) => {
            navigate(platformAgreementPath(slotCost), { replace: true });
        };

        if (!token) {
            redirect();
            return;
        }

        getAdvertiserAccount(token)
            .then((res) => redirect(res.data?.slotCost))
            .catch(() => redirect());
    }, [token, navigate]);

    return (
        <div className="advertiserDashboardContainer">
            <p style={{ padding: '2rem' }}>Opening advertising agreement…</p>
        </div>
    );
}
